import React from 'react';
import Button from '../../Components/Button';
const title = "IT'S NEVER LATE TO DECIDE FOR YOUR FUTURE";
const description =
  'Make the best use of learning from home, discover the best courses for you.';

const Explore = () => {

  return (
    <div className="liveclasses-explore-container">
      <div className="liveclasses-explore-content">
        <div className="liveclasses-explore-descriptor-container">
          <span className="liveclasses-explore-title">{title}</span>
          <span className="liveclasses-explore-description">{description}</span>
        </div>

        <Button text="EXPLORE OUR COURSES" link="#learn-about-courses" />
      </div>
    </div>
  );
};

export default Explore;



// WEBPACK FOOTER //
// ./src/Pages/LiveClasses/Explore.js